import { useEffect, useState } from 'react';

import { EnvConfig, EnvConfigResponse } from 'config/envConfig';
import { axiosInstance } from '../shared/axios/axiosConfig';
import { CN_MGMT_API_URL } from 'services/constants';

const useFetchEnvConfig = () => {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isFailure, setIsFailure] = useState<boolean>(false);
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    const fetchAppConfig = async () => {
      try {
        setIsFetching(true);
        // TODO: This API should be come from backend without the token.
        const res = await axiosInstance.get(`${CN_MGMT_API_URL}/frontend/feature-flags`);
        if (res.data) {
          const config = res.data as EnvConfigResponse;
          EnvConfig.config = { ...config.flags, hostUrl: config.hostUrl };
          setIsFetching(false);
          setIsSuccess(true);
        } else {
          throw new Error('Failed to fetch config');
        }
      } catch (err) {
        setIsFetching(false);
        setIsFailure(true);
        setError(err);
      }
    };
    fetchAppConfig();
  }, []);

  return { isFetching, isFailure, isSuccess, error };
};

export default useFetchEnvConfig;
